const SearchActionTypes = {
  SET_SEARCH_ITEM: 'SET_SEARCH_ITEM',
  SET_LOAD: 'SET_LOAD',
};

export default SearchActionTypes;
